export function validateEmail(email) {
  const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return re.test(String(email).toLowerCase());
}
export function placeHolder() {
  return null;
}
function containsUppercase(value) {
  return /[A-Z]/.test(value);
}
function containsLowercase(value) {
  return /[a-z]/.test(value);
}
function containsNumber(value) {
  return /[0-9]/.test(value);
}
function containsSpecial(value) {
  return /[\s^$*.[\]{}()?!"@#%&/\\,><':;|_~`+=-]/.test(value);
}

export function password(value) {
  return containsUppercase(value)
    && containsLowercase(value)
    && containsNumber(value)
    && containsSpecial(value);
}
